import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { getSettlementData } from '../../seller-apis/apidataField';
import api from '../../seller-apis/api';
import '../../assets/css/payment.css'
import PaymentCard from '../common/PaymentCard'
import { useAlert } from 'react-alert';
import { Route, Link, useLocation, Switch, NavLink, BrowserRouter, useRouteMatch, Redirect } from 'react-router-dom';
import SettlementsonHold from './Settlements/SettlementsOnHold';
import SettlementsCompleted from './Settlements/SettlementsCompleted';
import SettlementsDeduction from './Settlements/SettlementsDeduction';
import moment from 'moment';
import SettlementsPenalty from './Settlements/SettlementsPenalty';

var dateFromWeb = moment().subtract(29, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');
var allscrollLen = 0;
var globalFilter = {
    "pageNo": 1
};
const Settlements = () => {

    const [paymentHold, setpaymentHold] = useState("");
    const [paymentDone, setpaymentDone] = useState("");
    const [paymentDeduction, setpaymentDeduction] = useState("");
    const [penaltyDeduction, setPenaltyDeduction] = useState("");

    const { path, url } = useRouteMatch()
    useEffect(() => {
        globalFilter = {
            "pageNo": 1,
        }
        allscrollLen = 1;

        // Summary data

        api.vendorledger.getPaymentSettlements(getSettlementData({
            "pageNo": 1,
            "size": 1,
            "filters":{
                "status": "done",
                "from-paymentDate": dateFromWeb + 'T00:00:00.000Z',
                "to-paymentDate": dateToWeb + 'T23:59:59.000Z'
            } 
        })).then((res) => {
            setpaymentDone(res.totalRecords)
        }).catch(err => console.log(err))

        api.vendorledger.getPaymentRequests(getSettlementData({
            "pageNo": 1,
            "size": 1,
            "filters":{
                "requestForPayment-id": "hold",
                "from-deliveryDate": dateFromWeb + 'T00:00:00.000Z',
                "to-deliveryDate": dateToWeb + 'T23:59:59.000Z'
            }
        })).then((res) => {
            setpaymentHold(res.totalRecords)
        }).catch(err => console.log(err))

        api.vendorledger.getPaymentRequests(getSettlementData({
            "pageNo": 1,
            "size": 1,
            "filters":{
                "requestForPayment-id": "deduction",
                "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
                "to-createdAt": dateToWeb + 'T23:59:59.000Z'
            }
        })).then((res) => {
            setpaymentDeduction(res.totalRecords)
        }).catch(err => console.log(err))

        // SL-924(5-9-25)
          api.vendorledger.getPaymentRequests(getSettlementData({
            "pageNo": 1,
            "size": 1,
            "filters":{
                "requestForPayment-id": "penality-deduction",
                "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
                "to-createdAt": dateToWeb + 'T23:59:59.000Z',
                "action": "APPROVE"
            }
        })).then((res) => {
            setPenaltyDeduction(res.totalRecords)
        }).catch(err => console.log(err))

    }, [])

   

    return (
        <>
    
          <div className='filter_options_invent order_nav_cntn d-flex tab'>
    
              <NavLink exact to={`${url}/completed`} className="invent_nav"><button className='filter_options_btn_invent me-2' >Payment Done({paymentDone})</button></NavLink>
              <NavLink exact to={`${path}/onhold`} className="invent_nav"><button className='filter_options_btn_invent me-2'>Payment On Hold({paymentHold})</button></NavLink>
              <NavLink exact to={`${path}/deduction`} className="invent_nav"><button className='filter_options_btn_invent me-2'>Deduction Report({paymentDeduction})</button></NavLink>
              <NavLink exact to={`${path}/penalty`} className="invent_nav"><button className='filter_options_btn_invent me-2'>Penalty({penaltyDeduction})</button></NavLink>
          </div>
          {/* Routes */}
          <div>
            <Route exact path="/payment/settlements">
              <Redirect to={`${path}/completed`} />
            </Route>
            <Route path={`${path}/onhold`} component={SettlementsonHold} />
            <Route path={`${path}/completed`} component={SettlementsCompleted} />
            <Route path={`${path}/deduction`} component={SettlementsDeduction} />
            <Route path={`${path}/penalty`} component={SettlementsPenalty} />
          </div>
    
    
    
    
    
        </>
      )
}

export default Settlements